import { render, staticRenderFns } from "./columnDynamicData.vue?vue&type=template&id=fc80195e&scoped=true"
import script from "./columnDynamicData.vue?vue&type=script&lang=js"
export * from "./columnDynamicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc80195e",
  null
  
)

export default component.exports